import { ChatLimitSettings } from '../../../models/limits/chatLimits.model';
import { useGet, useSend } from '../../useApi';

// GET / PUT /admin/chat-limits/settings (each change audited, needs a reason).
const useChatLimitSettings = () => {
  const { data, loading, fetch, setData } = useGet<ChatLimitSettings>('Failed to load chat limits');
  const { loading: saving, send } = useSend<ChatLimitSettings>('Could not save the chat limits');
  return {
    settings: data,
    loading,
    saving,
    fetchSettings: () => fetch('api/v1/admin/chat-limits/settings'),
    save: (values: Record<string, number>, reason: string, onDone?: () => void) =>
      send({ url: 'api/v1/admin/chat-limits/settings', method: 'put', data: { values, reason } }, (body) => {
        setData(body);
        onDone?.();
      }),
  };
};

export default useChatLimitSettings;
